import React from 'react';
import styles from './Footer.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFacebookF,
    faLinkedinIn,
    faInstagram,
    faYoutube
} from '@fortawesome/free-brands-svg-icons';
import {
    faGlobe,
    faEnvelope
} from '@fortawesome/free-solid-svg-icons';
import logoIcon from "assets/logo.png";

export default function Footer() {
    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                <div className={styles.logoSection}>
                    <img src={logoIcon} alt="Logo" className={styles.logo} style={{ width: '186px' }} />
                </div>
                <div className={styles.links}>
                    <a className={styles.link} href="https://sensible-vr.com/privacy.html">
                        Privacy Policy
                    </a>
                    <a className={styles.link} href="https://sensible-vr.com/privacy.html">
                        Terms of Service
                    </a>
                    <a className={styles.link} href="https://sensible-vr.com/privacy.html">
                        Cookie Settings
                    </a>
                </div>
                <div className={styles.socials}>
                    <a className={styles.socialLink} href="https://www.facebook.com/profile.php?id=61579809143071">
                        <FontAwesomeIcon icon={faFacebookF} />
                    </a>
                    <a className={styles.socialLink} href="https://sensible-vr.com">
                        <FontAwesomeIcon icon={faGlobe} />
                    </a>
                    <a className={styles.socialLink} href="mailto:admin@sensible-vr.com">
                        <FontAwesomeIcon icon={faEnvelope} />
                    </a>
                    <a className={styles.socialLink} href="https://www.linkedin.com/company/sensible-vr/">
                        <FontAwesomeIcon icon={faLinkedinIn} />
                    </a>
                    <a className={styles.socialLink} href="https://youtube.com/@sensible-vr?si=_MiBN0J-jHJ7ql88">
                        <FontAwesomeIcon icon={faYoutube} />
                    </a>
                    <a className={styles.socialLink} href="https://www.instagram.com/sensiblevr_official?igsh=MWwyZjIyazQ2aXMyYw%3D%3D">
                        <FontAwesomeIcon icon={faInstagram} />
                    </a>
                </div>
            </div>
            <div className={styles.copyright}>
                © 2026 Sensible-VR Educational Platform. All rights reserved.
            </div>
        </footer>
    );
}